import { Button, Checkbox, Message, Modal } from "../../../../../BP2Components";
import projectConfig from "@projectConfig";
import React, { ReactNode, useState } from "react";
import IntlMessages from "../../../../../../util/IntlMessages";
import { useSelector } from "react-redux";
import { useTableListContext } from "../../../../../../context/TableListContext/TableListContext";
import "./addToGroupModal.less";
import { addObjectToGroup } from "../../../../../../services/restAPI/ListsV2";
import { useIntl } from "react-intl";

interface IAddToGroupModal {
   isOpen: boolean;
   onCancel: () => void;
   onClose: () => void;
   topBarTitle: ReactNode;
   listId: string;
}

const AddToGroupModal = ({ isOpen, onClose, topBarTitle, listId, onCancel }: IAddToGroupModal) => {
   const selectedRowIds = useSelector((state) => state.selectedRows.selectedRowIds);
   const [selectedGroups, setSelectedGroups] = useState<string[]>([]);
   const { listGroupsForMassActions, rowList } = useTableListContext();
   const intl = useIntl();
   const handleSelectGroup = (group, value) => {
      setSelectedGroups((prev) => {
         if (value && !prev.includes(group.id)) {
            return [...prev, group.id];
         } else {
            return prev.filter((id) => id !== group.id);
         }
      });
   };

   const handleClose = () => {
      onClose();
      setSelectedGroups([]);
   };

   const handleSave = async () => {
      try {
         const selectedRows = rowList.filter((row) => selectedRowIds.includes(row.ID));
         await Promise.all(
            selectedGroups.map((groupId) => addObjectToGroup(listId, groupId, selectedRows)),
         );
         Message.success(intl.formatMessage({ id: "global.success" }));
      } catch (err) {
         console.log(err);
         Message.error(intl.formatMessage({ id: "global.error" }));
      } finally {
         onClose();
      }
   };

   return (
      <Modal
         isOpen={isOpen}
         width={1080}
         onCancel={onCancel}
         height={window.innerHeight / 1.05}
         bodyStyles={{ overflowX: "auto", padding: "20px" }}
         topBarStyles={{
            justifyContent: "space-between",
            color: projectConfig.cssVariables["--topbar-text"],
            fontSize: "24px",
            fontWeight: "900",
            fontFamily: projectConfig.cssVariables["--font-primary"],
            padding: "20px",
         }}
         wrapClassName="no-resize"
         topBarContent={topBarTitle}
         onCancelButtonStyle={{ position: "relative", padding: "5px 0" }}
      >
         <div className="choose-object-field">
            <IntlMessages id="filter.selectedObjects" />
            <strong>{selectedRowIds.length}</strong>
         </div>
         <div className="group_list_wrapper">
            <strong>
               <IntlMessages id="massActions.groups" />
            </strong>
            <div className="group_list">
               {!!listGroupsForMassActions.length ? (
                  listGroupsForMassActions.map((group) => (
                     <Checkbox
                        checked={selectedGroups.includes(group.id)}
                        onChange={(e) => handleSelectGroup(group, e.target.value)}
                        key={group.id}
                     >
                        {group.name}
                     </Checkbox>
                  ))
               ) : (
                  <IntlMessages id="massActions.groups_is_not_exist" />
               )}
            </div>
         </div>
         <div className="create-group-modal__actions">
            <Button
               className="confirm-modal__button confirm-modal__button--cancel"
               onClick={handleClose}
            >
               <IntlMessages id="global.cancel" />
            </Button>
            <Button
               className="confirm-modal__button confirm-modal__button--confirm"
               onClick={handleSave}
               disabled={!selectedGroups.length || !selectedRowIds.length}
            >
               <IntlMessages id="global.save" />
            </Button>
         </div>
      </Modal>
   );
};

export default AddToGroupModal;
